// Header.jsx — Modern Design
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import '../../css/Header.css';
import '../../../src/App.css';
import { useGetMeQuery } from '../../redux/api/userApi';
import { useLazyLogoutQuery } from '../../redux/api/authApi';

export default function Header() {
  const navigate = useNavigate();
  const { data, isLoading, isFetching } = useGetMeQuery();
  const [logout] = useLazyLogoutQuery();
  const { user } = useSelector((state) => state.auth);

  if (isLoading || isFetching) return null;

  const logoutHandler = async () => {
    await logout();
    navigate(0);
  };

  return (
    <nav className="mbz-header">
      <div className="container-fluid">
        {/* Logo + Brand */}
        <Link to="/" id="linklogoid">
          {(user?.role !== 'driver') && (
            <img src="/images/MBZ-logobg.png" alt="MBZ Logo" className="mbz-icon" />
          )}
          {(user?.role === 'driver') && (
            <img src="/images/MBZ-Driverlogobg.jpg" alt="MBZ Logo" className="mbz-icon" />
          )}
          <span className="mbz-brand">MBZ Transport</span>
        </Link>

        {/* User Section */}
        <div id="dropdownid">
          {user ? (
            <>
              <button className="btn" id="dropDownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                <img
                  src={user?.avatar?.url || '/images/default_avatar.jpg'}
                  alt="Avatar"
                  className="avatar-img rounded-circle"
                />
                <span id="usernameidspan">
                  {user?.name?.length > 10 ? `${user.name.slice(0, 10)}...` : user?.name}
                </span>
              </button>
              <ul className="dropdown-menu">
                {user?.role === 'admin' && (
                  <li><Link className="dropdown-item" to="/admin/bookings">Admin Dashboard</Link></li>
                )}
                <li><Link className="dropdown-item" to="/me/profile">Profile</Link></li>
                {(user?.role === 'user' || user?.role === 'admin') && (
                  <li><Link className="dropdown-item" to="/me/bookings">My Bookings</Link></li>
                )}
                {user?.role === 'driver' && (
                  <>
                    <li><Link className="dropdown-item" to="/driver/mybookings">میری بکنگس</Link></li>
                    <li><Link className="dropdown-item" to="/driver/payment">پیمینٹ</Link></li>
                  </>
                )}
                <li>
                  <button className="dropdown-item text-danger" onClick={logoutHandler}>Logout</button>
                </li>
              </ul>
            </>
          ) : (
            <Link to="/login" className="btn btn-primary" id="loginbtnheader">Sign In</Link>
          )}
        </div>
      </div>
    </nav>
  );
}
